import { FormattedPercentage } from 'I18n/utils/internal/light/numberFormatters';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RatingDistribution({
  icon,
  iconProps,
  label,
  ratings
}) {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    children: [label, ratings.map(({
      key,
      value
    }) => /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-125",
        children: key
      }), /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInline: "0",
        children: /*#__PURE__*/_jsx(IconHolder, Object.assign({
          icon: icon,
          size: "200",
          paddingBlock: "0"
        }, iconProps))
      }), /*#__PURE__*/_jsx(Progress, {
        inlineSize: "150px",
        marginBlockEnd: "0",
        marginInlineEnd: "200",
        style: {
          background: trellisTheme.color['icon-tertiary-default']
        },
        value: value
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        children: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: value
        })
      })]
    }, key))]
  });
}